import React from 'react'
import { Cell, Grid, Skeleton, useContainerWidth } from '@fs/zion-ui'

export default function PageSkeleton() {
  const atWidth = useContainerWidth()

  return (
    <Grid>
      <Cell alignY="middle" columns={atWidth({ lg: 12 })}>
        <Skeleton.Image height={80} />
      </Cell>

      <Cell columns={atWidth({ lg: 4 })}>
        <Skeleton.Image height="calc(100vh - 150px)" />
      </Cell>

      <Cell columns={atWidth({ lg: 8 })}>
        <Grid>
          <Cell colums={8}>
            <Skeleton.Image height="calc(50vh - 150px)" />
          </Cell>
          <Cell colums={8}>
            <Skeleton.Image height="calc(50vh - 150px)" />
          </Cell>
        </Grid>
      </Cell>
    </Grid>
  )
}
